module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacettedConnections@2x.4ef1ca0.jpg";